import { http } from '../utils/http'

const getNameAction = (customer) => {
  const url = `/config/masterData/listName/${customer}`
  return http.post(url)
};
const getTypeAction = (params) => {
  const url = '/open/api/v1/master-data/dictionary/find'
  return http.post(url, params)
};
const searchAction = (params,page,size) => {
  let url = `/config/masterData/page`
  if( params.type && params.type === 'parameter') {
    url = `/config/dataMappingParameterData/page/${params.id}`
  }
  params.page = page
  params.size = size
  delete params.type
  return http.post(url, params)
};
const addAction = (params) => {
  let url = `/config/masterData/save`
  if( params.type && params.type === 'parameter') {
    url = `/config/dataMappingParameterData/save`
  }
  delete params.type
  return http.post(url, params)
};
const getAction = (params) => {
  let url = `/config/masterData/get/${params.id}`
  if( params.type && params.type === 'parameter') {
    url = `/config/dataMappingParameterData/get/${params.id}`
  }
  return http.post(url)
};
const editAction = (params,id) => {
  params.id = id
  let url = `/config/masterData/save`
  if( params.type && params.type === 'parameter') {
    url = `/config/dataMappingParameterData/save`
  }
  return http.post(url, params)
};
const deleteAction = (params) => {
  let url = `/config/masterData/delete/${params.id}`
  if( params.type && params.type === 'parameter') {
    url = `/config/dataMappingParameterData/delete/${params.id}`
  }
  return http.post(url)
};
const getCustAction = () => {
  const url = `/config/customer/list`
  return http.post(url, {})
};
// 导出
const exportAction = (params) => {
  const url = `/config/masterData/export`
  return http.post(url, params)
};
export default {
  getNameAction,
  getTypeAction,
  searchAction,
  addAction,
  getAction,
  editAction,
  deleteAction,
  getCustAction,
  exportAction
}
